import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  Input,
  OnDestroy
} from '@angular/core';
import { Stop } from '../../../@core/models/live-route';
import { AgmGoogleMapService } from '../../../@core/services/googlemap.service';
import { StopService } from '../../../@core/services/stop.service';
import { MarkerClusterDirective } from '../../directives/marker-cluster.directive';
import { AgmMarkerCluster } from '@agm/js-marker-clusterer';
import { Subscription } from 'rxjs';
import { LocationService } from '../../../@core/services/location.service';
import { LocationModel } from '../../../@core/models/location';
import { Address } from '../../../@core/models/address';
import { LiveRouteType } from '../../../@core/models/live-route-type';
import { AuthenticationService } from '../../../@core/services/authentication.service';
import { RouteTracePreferenceService } from '../../../@core/services/route-trace-preference.service';

@Component({
  selector: 'ngx-map-google-agm',
  styles: ['agm-map { height: 1000px; /* height is required */ }'],
  templateUrl: './map-google-agm.component.html',
  styleUrls: ['./map-google-agm.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapGoogleAgmComponent implements OnInit, OnDestroy {
  @ViewChild('markerCluster', { static: false }) markCluster;
  @Input() StopsList: Stop[];
  // initial center position for the map
  lat: number = 45.500922;
  lng: number = -73.443143;
  public zoom: number = 12;
  previousMarker: any;
  previousInfoWindow: any = null;
  infoWindowOpened: boolean = false;
  stops: Stop[];
  sub: Subscription;
  subStops: Subscription;
  subUser: Subscription;
  randOffsetLat: any;
  randOffsetLng: any;
  showRouteTrace: boolean = true;
  showStopPriority: boolean = false;
  showStopOrderColors: boolean = false;
  private markerLabelCache: { [key: string]: any } = {};
  private markerIconCache: { [key: string]: any } = {};

  get liverouteType() {
    return LiveRouteType;
  }

  get routeTraceSegments(): any[][] {
    return this.MarkerStore.polySegments;
  }

  nationexAddress: Address = {
    Name: 'Nationex',
    Address1: '3505 Boulevard Losch',
    Address2: '',
    Postal_Code: 'J3Y 5T7',
    City: 'Saint-Hubert',
    Latitude: 45.50084,
    Longitude: -73.44246,
    Phone: null
  };

  nationex: any = {
    Address: this.nationexAddress
  };

  clusterStyles: [
    {
      textColor: string;
      url: string;
      height: number;
      width: number;
      textSize: number;
      backgroundPosition: string;
    }
  ];

  clusterOptions: {
    gridSize: number;
    minimumClusterSize: number;
    averageCenter: boolean;
  };

  constructor(
    public _stopService: StopService,
    public _locationService: LocationService,
    public MarkerStore: AgmGoogleMapService,
    private authenticationService: AuthenticationService,
    private routeTracePreference: RouteTracePreferenceService
  ) {}

  ngOnInit() {
    this.showRouteTrace = this.routeTracePreference.getForCurrentUser();
    this.subUser = this.authenticationService.currentUser.subscribe(() => {
      this.showRouteTrace = this.routeTracePreference.getForCurrentUser();
    });

    this.clusterStyles = [
      {
        textColor: '#ff8a18',
        url: 'assets/markers/cluster-pin.png',
        height: 50,
        width: 50,
        textSize: 22,
        backgroundPosition: 'center center'
      }
    ];

    this.randOffsetLat = [];
    this.randOffsetLng = [];
    for (let i = 0; i < 1000; i++) {
      this.randOffsetLat.push(Math.random() / 5000);
      this.randOffsetLng.push(Math.random() / 5000);
    }

    this.clusterOptions = {
      gridSize: 20,
      minimumClusterSize: 2,
      averageCenter: true
    };

    this._locationService.setLocation({
      Latitude: this.lat,
      Longitude: this.lng,
      zoom: 12
    });

    this.subStops = this._stopService.currentStopsSubject.subscribe((data) => {
      /*this.stops = data.;
      if (this.stops.length > 1 && this.stops[0].No_Stop !== -1) {
        this.nationex.Route_ID = this.stops[0].Route_ID;
        this.nationex.No_Stop = -1;
        this.nationex.Min_Live_Route_Status = 0;
        //thia.Max_Live_Route_Status;
        this.stops.push(this.nationex);
      }*/
    });

    this.sub = this._locationService.locationSubject.subscribe((data) => {
      this.lat = data.Latitude;
      this.lng = data.Longitude;
      this.zoom = data.zoom;
      if (this.zoom > 12) {
        this.zoomIn();
      }
    });
  }

  zoomIn() {
    const intervalZoom = setInterval(() => {
      this.zoom = this.zoom + 1;
      if (this.zoom > 15) {
        clearInterval(intervalZoom);
      }
    }, 100);
  }

  clusterClicked(event: any) {}

  onRouteTraceToggle(event: any) {
    this.showRouteTrace = event.target.checked === true;
    this.routeTracePreference.setForCurrentUser(this.showRouteTrace);
  }

  onStopPriorityToggle(event: any) {
    this.showStopPriority = event.target.checked === true;
  }

  onStopOrderColorsToggle(event: any) {
    this.showStopOrderColors = event.target.checked === true;
  }

  markerLabel(stop: Stop): any {
    if (this.showStopPriority || this.showStopOrderColors) {
      return null;
    }

    const text = stop.No_Stop < 0 ? 'X' : '#' + stop.No_Stop.toString();
    if (!this.markerLabelCache[text]) {
      this.markerLabelCache[text] = {
        color: '#303030',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        fontWeight: 'bold',
        text
      };
    }
    return this.markerLabelCache[text];
  }

  markerIcon(stop: Stop, index: number): any {
    if (!this.showStopPriority && !this.showStopOrderColors) {
      const url = stop.isClicked ? 'assets/markers/marker-clicked.png' :
        stop.TotalPickup > 0 ? 'assets/markers/marker-pickup.png' :
          'assets/markers/marker0' + stop.Max_Live_Route_Status + stop.Max_Live_Route_Status + '.png';
      const key = 'legacy:' + url;
      if (!this.markerIconCache[key]) {
        this.markerIconCache[key] = {
          url,
          scaledSize: { width: 50, height: 70 },
          labelOrigin: { x: 23, y: 25 }
        };
      }
      return this.markerIconCache[key];
    }

    const priorityValue = Number(stop.Priority);
    const priority = this.showStopPriority && stop.Priority !== null && stop.Priority !== undefined &&
      stop.Priority !== '' && Number.isInteger(priorityValue) ? String(priorityValue) : '';
    const stopNumberValue = Number(stop.No_Stop);
    const stopNumber = Number.isInteger(stopNumberValue) && stopNumberValue >= 0 ? String(stopNumberValue) : 'X';
    const fill = this.showStopOrderColors ? this.routeSequenceColor(index, this.StopsList.length) : '#FFFFFF';
    const border = stop.isClicked ? '#B8D500' : stop.TotalPickup > 0 ? '#9B29A8' :
      this.showStopOrderColors ? '#19411F' : this.stopStatusColor(stop);
    const key = ['custom', priority, stopNumber, fill, border].join(':');
    if (!this.markerIconCache[key]) {
      const offset = priority ? 18 : 0;
      const circleY = 25 + offset;
      const height = 70 + offset;
      const textColor = this.markerTextColor(fill);
      const fontSize = stopNumber.length > 3 ? 12 : stopNumber.length > 2 ? 14 : 17;
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="${height}" viewBox="0 0 50 ${height}">` +
        (priority ? `<text x="25" y="15" font-family="Arial" font-size="14" font-weight="bold" text-anchor="middle" fill="#111" stroke="#fff" stroke-width="3" paint-order="stroke">${priority}</text>` : '') +
        `<path d="M25 ${height - 1} L17 ${circleY + 13} L33 ${circleY + 13} Z" fill="${border}"/>` +
        `<circle cx="25" cy="${circleY}" r="21" fill="${fill}" stroke="${border}" stroke-width="5"/>` +
        `<text x="25" y="${circleY + 1}" font-family="Arial" font-size="${fontSize}" font-weight="bold" text-anchor="middle" dominant-baseline="middle" fill="${textColor}">${stopNumber}</text>` +
        '</svg>';
      this.markerIconCache[key] = {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
        scaledSize: { width: 50, height }
      };
    }
    return this.markerIconCache[key];
  }

  private routeSequenceColor(index: number, count: number): string {
    const progress = count <= 1 ? 0 : Math.max(0, Math.min(index, count - 1)) / (count - 1);
    const channel = (start: number, end: number) =>
      Math.round(start + (end - start) * progress).toString(16).padStart(2, '0').toUpperCase();
    return '#' + channel(211, 25) + channel(255, 65) + channel(233, 31);
  }

  private markerTextColor(background: string): string {
    const red = parseInt(background.substr(1, 2), 16);
    const green = parseInt(background.substr(3, 2), 16);
    const blue = parseInt(background.substr(5, 2), 16);
    return (0.299 * red + 0.587 * green + 0.114 * blue) / 255 > 0.6 ? '#000000' : '#FFFFFF';
  }

  private stopStatusColor(stop: Stop): string {
    switch (Number(stop.Max_Live_Route_Status)) {
      case 1: return '#238C87';
      case 2: return '#0080FF';
      case 3: return '#FF0000';
      case 4: return '#006234';
      default: return '#4F4F4F';
    }
  }

  markerClicked(m: any, i: number, infoWindow: any) {
    m.isClicked = true;
    if (this.previousMarker) {
      this.previousMarker.isClicked = false;
    }
    this.previousMarker = m;
    if (this.previousInfoWindow !== null) {
      this.infoWindowOpened = infoWindow;
      this.previousInfoWindow.close();
    }
    this.previousInfoWindow = infoWindow;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.subStops) {
      this.subStops.unsubscribe();
    }
    if (this.subUser) {
      this.subUser.unsubscribe();
    }
  }

  closeWindow() {
    if (this.previousInfoWindow !== null) {
      this.previousInfoWindow.close();
    }
  }
}
